"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRewardStatusV1 = void 0;
function isRewardStatusV1(rs) {
    return rs.protocolVersion !== undefined && rs.protocolVersion > 3n;
}
exports.isRewardStatusV1 = isRewardStatusV1;
